import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-signed-certificate-dialog',
  templateUrl: './signed-certificate-dialog.component.html',
  styleUrls: ['./signed-certificate-dialog.component.scss']
})
export class SignedCertificateDialogComponent implements OnInit {

  form: FormGroup;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      password: [null,[Validators.required]],
    });
  }

  closeModal(result:any = null){
    this.activeModal.close(result);
  }

  confirm(){
    this.activeModal.close(this.form.value.password);
  }
}